import { render, staticRenderFns } from "./metric-distribution.vue?vue&type=template&id=6b25dd70&scoped=true"
import script from "./metric-distribution.vue?vue&type=script&lang=js"
export * from "./metric-distribution.vue?vue&type=script&lang=js"
import style0 from "./metric-distribution.vue?vue&type=style&index=0&id=6b25dd70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b25dd70",
  null
  
)

export default component.exports